import { TextField } from "@fluentui/react";
import { Controller, useFormContext } from "react-hook-form";

import type { LineAdditionalServicesNotesFormValues } from "../../interfaces";

interface LineAdditionalServiceDetailsFormValues {
  isChargeExempt: boolean;
  notes: LineAdditionalServicesNotesFormValues;
}

export function LineAdditionalServiceDetailsForm(): JSX.Element {
  const { control, watch } =
    useFormContext<LineAdditionalServiceDetailsFormValues>();
  const isChargeExempt = watch("isChargeExempt");

  return (
    <Controller
      name="notes.details"
      control={control}
      render={({ field, fieldState }) => (
        <TextField
          label={isChargeExempt ? "Motivo da isenção" : "Detalhes"}
          placeholder={
            isChargeExempt
              ? "Ex.: isenção autorizada por..."
              : "Insira informações adicionais"
          }
          multiline
          rows={3}
          value={field.value ?? ""}
          onChange={(_, value) => field.onChange(value ?? "")}
          errorMessage={fieldState.error?.message}
          required={isChargeExempt}
        />
      )}
    />
  );
}
